import ApiService from "../../utils/fetch";
const userRolesUrl = `${process.env.REACT_APP_BASE_URL}`;

export const createSupportTicket = async (payload) => {
  const url = `${userRolesUrl}support/ticket`;
  const response = await ApiService.post(url, payload);
  return response.data;
};